<template>
  <div class="carInfo">
    <div class="l1">
      <label for="l1" class="liLabel">{{carNo}}</label>
      <button class="l1btn">{{status}}</button>
    </div>
    <div class="seperate"></div>
    <div class="l2"> 
        <div class="l2box">
          <label for="l21" class="l2t">{{embarkProgress}}</label>
          <label class="l2s">装载率</label>
        </div>
        <div class="seperateVertival"></div>
        <div class="l2box">
          <label for="l21" class="l2t2">{{carLength}}</label>
          <label class="l2s">车型(米)</label>
        </div>
    </div>
    <div v-if="collapsed" class="l3">
        <el-button icon="el-icon-arrow-down" @click="collapsed=false" class="l3btn"></el-button>
    </div>
    <div v-if="!collapsed" class="l4">
        <div v-for="(item, index) in itemArr" :key="index" class="l4box">
            <label class="l4t">{{item.label}}:</label>
            <label class="l4v">{{item.value}}</label>
        </div>
    </div>
    <div v-if="!collapsed" class="l3">
        <el-button icon="el-icon-arrow-up" @click="collapsed=true" class="l3btn"></el-button>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            carNo: '粤X 888888',
            embarkProgress: '0',
            carLength: '',
            collapsed: false,
            itemArr: [],
            status: ''
        };
    },
    mounted() {
        this.itemArr = [
            { 'label': '订单号', 'value': this.data.doNo },
            { 'label': '司机', 'value': this.data.driverName },
            { 'label': '司机号码', 'value': this.data.driverTel },
            { 'label': '模式', 'value': this.data.dispatchType },
            { 'label': '任务数量', 'value': this.data.taskQuantity },
            { 'label': '计划到货时间', 'value': this.data.reqArriveTime }
        ];
        this.carNo = this.data.vehicleNo;
        this.carLength = this.data.vehicleTypeName;
        this.embarkProgress = this.data.loadRate;
        this.status = this.data.dispatchStatusName;
    },
    watch: {
        data: function() {
            this.itemArr = [
                { 'label': '订单号', 'value': this.data.doNo },
                { 'label': '司机', 'value': this.data.driverName },
                { 'label': '司机号码', 'value': this.data.driverTel },
                { 'label': '模式', 'value': this.data.dispatchType },
                { 'label': '任务数量', 'value': this.data.taskQuantity },
                { 'label': '计划到货时间', 'value': this.data.reqArriveTime }
            ];
            this.carNo = this.data.vehicleNo;
            this.carLength = this.data.vehicleTypeName;
            this.embarkProgress = this.data.loadRate;
            this.status = this.data.dispatchStatusName;
        }
    } 
};
</script>

<style lang="less">
.carInfo {
    width: 242px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    .l1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 47px;
        height: 47px;
        .liLabel {
            font-size: 18px;
            color: #333;
            margin-left: 20px;
        }
        .l1btn {
            height: 20px;
            line-height: 20px;
            background-color: rgba(0, 191, 191, 0.1);
            border: 1px solid #00bfbf;
            color: #00bfbf;
            margin-right: 20px;
        }
    }
    .seperate {
        height: 1px;
        background-color: #ededed;
        width: 200px;
        margin: 0 auto;
    }
    .l2 {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 75px;
        .seperateVertival {
            height: 30px;
            width: 1px;
            background-color: #ededed
        }
        .l2box {
            width: 120px;
            height: 75px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .l2t {
                line-height: 28px;
                font-size: 20px;
                color: #00bfbf;
            }
            .l2t2 {
                line-height: 28px;
                font-size: 20px;
                color: #333
            }
            .l2s {
                line-height: 17px;
                font-size: 12px;
                color: #999;
            }
        }
    }
    .l3 {
        height: 26px;
        .l3btn{
            width: 100%;
            height: 26px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            border: none;
        }
    }
    .l4box {
       display: flex;
       justify-content: flex-start;
       height: 30px;
       font-size: 12px;
       line-height: 30px;
       margin-left: 20px;
       .l4t {
         color: #999;
       }
       .l4v {
         color: #333;
         margin-left: 10px;
       }
    }

}

</style>
